import type { Library, User } from "@quill/shared";

/**
 * Small per-device cache so the app opens offline: the signed-in user and the last
 * library listing. Document bodies live in IndexedDB (y-indexeddb), not here.
 */

const USER_KEY = "quill.user";
const libraryKey = (userId: string) => `quill.library.${userId}`;

function read<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

function write(key: string, value: unknown) {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage full or blocked: the app still works online.
  }
}

export const cache = {
  user: () => read<User>(USER_KEY),
  setUser: (u: User | null) => write(USER_KEY, u),
  library: (userId: string) => read<Library>(libraryKey(userId)),
  setLibrary: (userId: string, lib: Library) => write(libraryKey(userId), lib),
};
